export default "__VITE_PUBLIC_ASSET__56a53515__"